// src/components/WineClub/WineClubBenefits.tsx

import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import wineBottleSvg from '../../assets/images/wineBottle.svg';
import meatsCheeseSvg from '../../assets/images/meatsCheese.svg';
import benefitsGrapesSvg from '../../assets/images/BenefitsGrapes.svg';
import JoinWineClubModal from './JoinWineClubModal';


const WineClubBenefits: React.FC = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const openModal = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  return (
    <div className="bg-gold text-cream font-medium p-8">
      <h2 className="text-3xl md:text-4xl lg:text-5xl font-recia tracking-extraWide mb-4 text-center">
        BENEFITS
      </h2>
      <p className="text-center font-recia mb-8">
        Priority pickup at Via Maestra Enoteca
      </p>
      <div className="max-w-6xl mx-auto flex flex-col md:flex-row justify-center items-center md:space-x-8 space-y-8 md:space-y-0">
        {/* Left Column */}
        <div className="flex flex-col items-center text-center">
          <img src={wineBottleSvg} alt="Wine Bottle" className="w-auto h-16 mb-4" />
          <p className="font-satoshi">
            Monthly selection of <br /><span className="font-bold">2 premium wines</span>
          </p>
        </div>
        {/* Center Column */}
        <div className="flex flex-col items-center text-center">
          <img src={meatsCheeseSvg} alt="Meats and Cheese" className="w-auto h-16 mb-4" />
          <p className="font-satoshi">
            A full pound of Italian meats. <br />Half a pound of Italian cheeses.
          </p>
        </div>
        {/* Right Column */}
        <div className="flex flex-col items-center text-center">
          <img src={benefitsGrapesSvg} alt="Grapes" className="w-auto mt-4 h-12 mb-4" />
          <p className="font-satoshi text-balance">
            Exclusive access to special <br />events and tastings
          </p>
        </div>
      </div>
      <div className="max-w-6xl mx-auto flex flex-col md:flex-row justify-center items-center md:space-x-8 space-y-8 md:space-y-0 pt-8">
        <div className="relative max-w-xl rounded-2xl overflow-hidden shadow-lg bg-black/50">
            <img src="/bg-join-us.jpg" loading="lazy" className="w-full h-full object-cover" />
            <div className="absolute top-0 left-0 right-0 w-full h-full rounded-2xl">
                <div className="flex flex-col p-6 h-full text-white justify-center items-center">
                    <h2 className="text-xl md:text-2xl text-white/90">Join the Wine Club</h2>
                    <p className="font-satoshi max-w-sm mt-4 text-xs text-white/90 text-center">Call us today to get exclusive benefits including monthly wine selection, Italian meats and cheese and much more!</p>
                    <Link to="tel:(805) 563-6311">
                        <button className="mt-4 inline-flex rounded-full px-4 py-2 bg-maroon text-cream font-satoshi text-sm w-max uppercase hover:bg-olive transition-colors duration-300">
                            Call Now
                        </button>
                    </Link>
                </div>
            </div>
        </div>
      </div>
      {/* Join the Wine Club Button 
      <div className="text-center mt-8">
        <button
          className="bg-maroon text-cream font-satoshi px-6 py-2 rounded-full"
          onClick={openModal}
        >
          Join the Wine Club
        </button>
      </div>
      */}
      {/* Modal */}
      <JoinWineClubModal isOpen={isModalOpen} onClose={closeModal} />
    </div>
  );
};

export default WineClubBenefits;